import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dmb-expansion-panel-header',
  template: '<ng-content/>',
  styleUrls: ['./expansion-panel-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpansionPanelHeaderComponent {}
